import React from 'react';

interface SectionProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
    id?: string;
}

export const Section: React.FC<SectionProps> = ({ children, style = {}, id }) => {
    const sectionStyle: React.CSSProperties = {
        width: '100%',
        paddingTop: '72px',
        paddingBottom: '72px',
        paddingLeft: '20px',
        paddingRight: '20px',
        ...style,
    };

    const containerStyle: React.CSSProperties = {
        maxWidth: '1120px',
        margin: '0 auto',
        width: '100%',
    };

    return (
        <section id={id} style={sectionStyle} className="sectionPadding">
            <div style={containerStyle}>
                {children}
            </div>
        </section>
    );
};

